import { render, staticRenderFns } from "./ShowCustomLayout.vue?vue&type=template&id=4f6a463a&scoped=true"
import script from "./ShowCustomLayout.vue?vue&type=script&lang=js"
export * from "./ShowCustomLayout.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomLayout.vue?vue&type=style&index=0&id=4f6a463a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a463a",
  null
  
)

export default component.exports